export function requestFlutterVersion() {
  if (window.FlutterApp == null) return

  try {
    window.FlutterApp.postMessage('APP_VERSION')
  } catch (e) {
    console.error('[FlutterApp] Erro ao solicitar versão:', e)
  }
}
